export default function tooltip({ variables }) {
    const band = `var(--tooltip-band, ${variables.surface_band})`;
    const cardEdge = `1px solid ${variables.border_subtle}`;
    const cardArrow = '.MuiTooltip-arrow[data-tooltip-type="card"]';
    return {
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    [`&[data-popper-placement*="bottom"] ${cardArrow}`]: {
                        color: band,
                        "&::before": { borderTop: cardEdge, borderLeft: cardEdge },
                    },
                    [`&[data-popper-placement*="top"] ${cardArrow}`]: {
                        "&::before": { borderRight: cardEdge, borderBottom: cardEdge },
                    },
                    [`&[data-popper-placement*="right"] ${cardArrow}`]: {
                        "&::before": { borderBottom: cardEdge, borderLeft: cardEdge },
                    },
                    [`&[data-popper-placement*="left"] ${cardArrow}`]: {
                        "&::before": { borderTop: cardEdge, borderRight: cardEdge },
                    },
                },
                tooltip: {
                    fontSize: variables.type_body_xs_font_size,
                    backgroundColor: variables.surface_inverse,
                    borderRadius: variables.border_radius_small,
                    padding: `${variables.spacing_02} ${variables.spacing_03}`,
                    "&[data-tooltip-fit-content]": {
                        minWidth: "fit-content",
                    },
                },
                arrow: {
                    color: variables.surface_inverse,
                    '&[data-tooltip-type="card"]': {
                        color: variables.surface,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=tooltip.js.map